<router-outlet></router-outlet>
<div class="container my-5 text-muted text-center">
  Qalea Pass<br />
  {{ "versionNumber" | i18n: version }}
  <br /><br />
  <div class="small">
    &reg; Qalea.
    <!-- context -->
    <!-- context -->
  </div>
</div>
